import React from "react";

export default function RefundPolicy() {
  return (
    <div className="relative overflow-hidden bg-[#FFF8EE] pt-28 pb-20 min-h-screen">
      {/* Background Gradients */}
      <div className="absolute top-[-250px] left-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.12)_0%,transparent_70%)] pointer-events-none" />
      <div className="absolute bottom-[-300px] right-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.1)_0%,transparent_70%)] pointer-events-none" />

      <div className="relative z-20 max-w-[960px] mx-auto px-6">
        <div className="rounded-[40px] border border-[#F4D9B5] bg-white/70 backdrop-blur-2xl p-8 md:p-14 shadow-[0_20px_60px_rgba(0,0,0,0.03)]">
          <h1 className="text-[36px] md:text-[50px] font-bold text-[#111111] font-poppins mb-4" style={{ fontFamily: "Poppins" }}>Refund & Cancellation Policy</h1>
          <p className="text-xs text-[#777] mb-10">Last Updated: June 29, 2026</p>
          
          <div className="prose max-w-none text-[#444] text-[15px] leading-[30px] space-y-8">
            <p>
              We want you to be fully satisfied with your wellness journey at Divyyog Foundation. This policy describes our cancellation rules and refund eligibility for courses, live batches, and certifications.
            </p>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>1. Trial & Free Classes</h2>
              <p>
                We offer a 7-day free trial on selected plans to give you an opportunity to experience our classes before committing to a paid membership. There are no charges during the trial period, and you can cancel anytime.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>2. Membership Refunds</h2>
              <p>
                Refund rules for paid memberships are as follows:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Monthly Memberships:</strong> Monthly plans are non-refundable. You can cancel your renewal at any time, and you will continue to have access until the end of your billing cycle.</li>
                <li><strong>Quarterly & Annual Memberships:</strong> If you purchase a long-term plan (3-month, 6-month, or annual) and request a refund within <strong>7 days</strong> of purchase, you may receive a full refund minus processing fees. After 7 days, payments are non-refundable.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>3. Teacher Training Programs (YTT)</h2>
              <p>
                Professional teacher training programs involve dedicated slots and instructor preparation. A refund request for teacher training must be submitted at least <strong>14 days prior</strong> to the course start date to receive a full refund. Requests made less than 14 days before the start are eligible for a 50% refund. Once the course has started, no refunds will be granted.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>4. How to Request a Refund</h2>
              <p>
                To request a refund or cancel your subscription, please email us at <strong>billing@divyyog.org</strong> with your registered name, email address, transaction reference ID, and reason for cancellation. Approved refunds will be credited back to your original payment method within 5–7 business days.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
